import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "../api/axiosClient";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    
    // On mount, check if user token exists in localStorage and verify
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            // Optionally verify token validity with backend here
            setUser({ token }); // Minimal, can fetch user profile if API supports
        }
        setLoading(false);
    }, []);
    
    const login = async (identifier, password) => {
        try {
            const response = await axios.post("/auth/login",
                { identifier, password }, {withCredentials: true});
            const { token, refreshToken, user } = response.data.data;
            
            localStorage.setItem("token", token);
            localStorage.setItem("refreshToken", refreshToken);
            setUser(user);
            
            navigate("/"); // Redirect after login
        } catch (error) {
            throw error; // Let UI handle errors
        }
    };
    
    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        setUser(null);
        navigate("/login");
    };
    
    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
